import AccountingInfoOption from './AccountingInfoOption';

export default class NonResidentFinancialSector extends AccountingInfoOption {
    public static entity = 'nonResidentFinancialSectors';
    public static apiType = 'non-resident-financial-sectors';
    public static storageKey = 'non_resident_financial_sectors_list';
}